// Nome da forma de pagamento pra mostrar no pedido.
//
// O pedido guarda o que a loja usou na hora: uma chave do sistema ("pix"), o texto
// já pronto ("Dinheiro", "No Fechamento") ou o CÓDIGO da forma cadastrada pela loja
// ("cartao_<id da loja>"). Sem tradução, o código aparecia cru no card e quebrava o
// layout em duas linhas (v1.5.726).

const BASE = {
  dinheiro: "Dinheiro", cartao: "Cartão", credito: "Crédito", debito: "Débito", pix: "PIX",
  // Dividido sem as partes gravadas: não há de onde tirar os valores (dono, 24/09/2026)
  multiplo: "Várias formas (sem detalhe)", misto: "Várias formas (sem detalhe)",
  voucher: "Voucher", vale: "Vale", nota: "Nota",
  ifood_marketplace: "iFood", marketplace: "Marketplace", pix_online: "PIX online",
  pagar_na_retirada: "Paga na retirada", no_fechamento: "No fechamento", online: "Online",
};

const semAcento = (t) => String(t || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
const capitalizar = (t) => t.charAt(0).toUpperCase() + t.slice(1);

// `metodos`: mapa código/id → { name, icon } vindo de /api/payment-methods.
export function rotuloPagamento(valor, metodos = {}) {
  const bruto = String(valor || "").trim();
  if (!bruto) return "—";
  const cadastrado = metodos[bruto] || metodos[bruto.toLowerCase()];
  if (cadastrado?.name) return cadastrado.name;
  const chave = semAcento(bruto).replace(/\s+/g, "_");
  if (BASE[chave]) return BASE[chave];
  // "cartao_9824…" (código da loja que não veio na lista): fica só a parte legível.
  const semId = chave.replace(/_[0-9a-f]{8}-[0-9a-f-]{20,}$/i, "");
  if (BASE[semId]) return BASE[semId];
  if (/^[0-9a-f-]{20,}$/i.test(bruto)) return "Outro";
  // Já é nome ("Vale Refeição", "Dinheiro + PIX"): fica como está, com acento.
  if (semId === chave && /[A-ZÀ-ÿ\s+]/.test(bruto)) return bruto;
  return capitalizar(semId.replace(/_/g, " "));
}

export function emojiPagamento(valor, metodos = {}) {
  const m = metodos[String(valor || "").trim()];
  return m?.icon && !/^https?:/.test(m.icon) ? m.icon : null;
}
